import React, { useEffect } from "react";
import { useAlert } from "react-alert";
import { useStateIfMounted } from "use-state-if-mounted";
import { encode as base64_encode } from "base-64";
import { useHistory, useLocation } from "react-router-dom";
const appparameters = require("../../../core/common.jsx");

export default function Forgetpass(props) {
  const [state, setState] = useStateIfMounted({
    pass: "",
    cpass: "",
    disabled: false,
  });
  const history = useHistory();
  const alert = useAlert();
  const location = useLocation();
  // See activateaccount.jsx for why this reads the query string rather than
  // route params: a signed JWT can exceed the filesystem's 255-byte
  // per-path-segment limit, and putting it in the URL PATH triggers a raw
  // ENAMETOOLONG error from the static file server before this page ever loads.
  const searchParams = new URLSearchParams(location.search);
  const username = searchParams.get("username");
  const token = searchParams.get("token");
  useEffect(() => {
    //componentDidMount || componentDidUpdate
    //console.log("use effect executed!");
  });

  useEffect(() => {
    setState({ ...state, disabled: false });
    if (username == undefined || token == undefined) {
      history.push("/");
      alert.show("Unauthorized page request", {
        type: "error",
        position: "middle",
      });
    }
  }, []);

  const submitlogin = (e) => {
    setState({ ...state, disabled: true });
    let can_proceed = true;
    let passstrongRegex =
      /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,64}$/;
    if (!passstrongRegex.test(state.pass)) {
      can_proceed = false;
      setState({ ...state, pass: "", cpass: "", disabled: false });
      alert.show(
        "Password must be minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character",
        { type: "error", position: "middle" }
      );
      return;
    }
    if (state.pass != state.cpass) {
      can_proceed = false;
      setState({ ...state, pass: "", cpass: "", disabled: false });
      alert.show("Confirm password doesn't match New password", {
        type: "error",
        position: "middle",
      });
      return;
    }
    if (can_proceed) {
      //let temp_state = { ...state };
      //temp_state.pass = base64_encode(temp_state.pass);
      //delete temp_state.cpass;
      //delete temp_state.disabled;
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username,
          token,
          pass: base64_encode(state.pass),
        }),
      };
      fetch(
        appparameters.backend_app_url + "/frontend/forgetpass",
        requestOptions
      ) //window.location.origin +
        .then((response) => response.json())
        .then((responseData) => {
          if (responseData) {
            history.push("/");
            alert.show("Password changed successfully", { type: "success" });
          } else {
            setState({ ...state, disabled: false });
            alert.show("Failed request", { type: "error", position: "middle" });
          }
        })
        .catch((error) => console.warn(error));
    }
  };
  if (state.disabled) {
    return (
      <div className="container">
        <center>
          <img
            src={require("./../../../images/simpleloading.gif")}
            className="simpleloadingview"
          />
          <p>
            <strong>Loading ...</strong>
            <br />
          </p>
        </center>
      </div>
    );
  } else {
    return (
      <React.Fragment>
        <div className="row loginrow">
          <div className="login">
            <h1>&nbsp;</h1>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                submitlogin();
              }}
            >
              <input
                type="password"
                placeholder="New password"
                required="required"
                value={state.pass}
                onChange={(e) => setState({ ...state, pass: e.target.value })}
              />
              <input
                type="password"
                placeholder="Confirm password"
                required="required"
                value={state.cpass}
                onChange={(e) => setState({ ...state, cpass: e.target.value })}
              />
              <p>&nbsp;</p>
              <button
                type="submit"
                className="btn btn-primary btn-block btn-large"
              >
                Confirm
              </button>
            </form>
            <br></br>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
